module.exports = __webpack_public_path__ + "static/media/AnnualLeave.06c96f99.svg";